<div class="landing-page-contianer">
    <div class="mob-logo d-flex justify-content-center align-items-center">
        <img
            alt="Uniqode"
            class="mob-logo-img"
            src="/logo/uniqode-header-logo.svg"
        />
    </div>

    <div class="mob-share-container">
        <div class="mob-welcome-text text-center">
            <span class="mob-welcome"> Get the Uniqode Cards app </span>
        </div>
        <div
            class="mob-disclaimer-info d-flex justify-content-center align-items-center"
        >
            <span class="mob-info-text"
                >Install the app to view, share, and manage your cards -
                faster and built for your phone.</span
            >
        </div>

        <div class="d-flex justify-content-center align-items-center mb-2 mt-3">
            <div class="mob-dbc-gif-container">
                <img
                    alt="Landing pwa gif"
                    class="landing-pwa"
                    src="img/pwa-landing-page.png"
                />
            </div>
        </div>
    </div>
    <div class="floating-bottom-container">
        <div
            (click)="redirectToMobileApp()"
            class="floating-button-install-app cursor-pointer"
        >
            <span class="text-white pointer-events-none">Install App</span>
        </div>
    </div>
</div>
